import React from 'react';
import { Button } from '@nextui-org/react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router';
import { FamilyFormData } from '../../../types/families';
import { createUserFamily } from '../../../service/families';
import { useSelector } from 'react-redux';
import { StoreState } from '../../../store/reducer-main';
import PageLayout from '../../components/common/PageLayout';
import theme from '../../theme';
import FamilyForm from '../../components/others/forms/FamilyForm';
import { toast } from 'react-toastify';
import { brkRef } from '../../../helpers/utils';

const persone = [ // per test
  { nome: "Mario", cognome: "Rossi" },
  { nome: "Luigi", cognome: "Bianchi" },
  { nome: "Anna", cognome: "Esposito" },
  { nome: "Sara", cognome: "Ferri" },
  { nome: "Giovanni", cognome: "Romano" },
  { nome: "Paolo", cognome: "Santoro" },
  { nome: "Francesca", cognome: "Gatti" },
  { nome: "Carlo", cognome: "Barbieri" },
  { nome: "Elena", cognome: "Moretti" },
  { nome: "Marco", cognome: "Monti" },
  { nome: "Alessia", cognome: "Fontana" },
  { nome: "Giorgio", cognome: "Costa" },
  { nome: "Lucia", cognome: "Martini" },
  { nome: "Claudio", cognome: "Greco" },
  { nome: "Valeria", cognome: "De Luca" },
  { nome: "Stefano", cognome: "Marini" },
  { nome: "Simona", cognome: "Lombardi" },
  { nome: "Federico", cognome: "Conti" },
  { nome: "Martina", cognome: "Ricci" },
  { nome: "Davide", cognome: "Pellegrini" }
];

export default function CreateFamilyPage() {

  const navigate = useNavigate();

  const { userProfile } = useSelector((state: StoreState) => state.profile);

  const [loading, setLoading] = React.useState<boolean>(false);

  const submit = async(
    formData: FamilyFormData
  ) => {
    try {
      if (!userProfile) return;
      setLoading(true);
      /* for (let i = 0; i < persone.length; ++i) {
        const ffd = brkRef(formData);
        ffd.personalData.name = persone[i].nome;
        ffd.personalData.surname = persone[i].cognome;
        await createUserFamily(userProfile.uid, ffd);
      } */
      await createUserFamily(userProfile.uid, formData);
      setLoading(false);
      toast.success('Famiglia creata con successo');
      navigate(-1);
    } catch (error) {
      setLoading(false);
    }
  }

  return (
    <PageLayout nestedPage>
      <div className='flex justify-between items-center'>
        <div className='flex flex-row gap-4 items-center'>
          <Button isIconOnly aria-label="back" color='primary' size='sm' onClick={() => navigate(-1)} radius='full'>
            <ArrowBackIcon />
          </Button>
          <p className='text-xl font-medium'>Nuova Famiglia</p>
        </div>
      </div>
      <FamilyForm
        interviewMode
        className='mt-6 p-4'
        style={{
          borderRadius: theme.sizing.x2,
          backgroundColor: theme.color.background,
          border: '1.5px solid lightgray'
        }}
        loading={loading}
        onCancel={() => navigate(-1)}
        onSubmit={submit}/>
    </PageLayout>
  )
}